









































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import editor from '@/components/common/summernote/Index.vue';
import {PopupRequestData} from '@/types';
import {  Mall,PostMailRequest, GetMailPublicAppkeyValidationRequest, GetMembersRequest, GetMallsDataRequest} from 'supporter';
import {i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/ncp';
import {addDay} from '@/utils/dateUtils';
import {State, namespace} from 'vuex-class';
const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    MallsTab,
    CompSelectBox,
    editor,
    DateCalendar
  }
})
export default class Dispatch extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private selectedDate: any = '';
  private memberCount: number = 0;
  private memberNoList: number[] = [];
  private memberNoList4Jason: any[] = [];
  private memberList: any[] = [];
  private templateNo: number = 0;
  private emailUsed: boolean = false;
  private emailFront: string = 'noreply';
  private emailEnd: string = 'naver.com';
  private isAd: boolean = false;
  private isTemplateUsed: boolean = false;
  private isShowNotice: boolean = false;
  private isSendImmediate: boolean = true;
  private recipient: string = 'selectMember';
  private recipientType: string = 'MEMBER_NO';
  private sendInformationType: string = '';
  private title: string = '';
  private contentDate: string = '';
  private previewTitle: string = '';
  private previewContents: string = '';
  private isPreview: boolean = false;
  private isAppKeyConfigured: boolean = false;
  private attachedFileName: string = '';

  private editorContent: {noticeContent: string; searchContent: string} = {
    noticeContent: '',
    searchContent: ''
  };

  private editorOptions = {
    useVideo: true,
    insertList: ['link', 'picture', 'video'],
    toolbar: [
      ['fontsize', ['fontsize']],
      ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
      ['color', ['color']],
      ['para', ['paragraph']],
      ['height', ['height']],
      ['picture', ['link', 'picture', 'video']],
      ['misc', ['codeview']]
    ],
  };

  private getMemberRequest: GetMembersRequest = {
    params: {
      mallNo: 0,
      page: 1,
      pageSize: 30,
      types: 'MALL,SYNC_ID,OPEN_ID',
      searchType: 'ALL'
    }
  };

  private async getMemberCount() {
    this.getMemberRequest.params.mallNo = Number(this.mallNo);
    this.getMemberRequest.params.status = 'ACTIVE';
    if(this.isAd){
      this.getMemberRequest.params.emailAgreed = true;
    }else{
      this.getMemberRequest.params.emailAgreed = undefined;
    }

    let {data} = await this.$api.getMembers(this.getMemberRequest);
    this.memberCount = data.totalCount;

    // let request = {
    //   params: {
    //     mallNo: Number(this.mallNo)
    //   }
    // };
    // this.$api.getMemberGrades(request).then((res): any => {
    //   res.data.forEach(grade => this.memberCount += grade.memberCount)
    // });
  }

  private changeSendInformationType() {
    if ($('#sendInformationType').prop('selectedIndex') === 2) {
      this.isAd = true;
    } else {
      this.isAd = false;
    }
  }

  private doRecipientRadio(value: string) {
    this.memberCount = 0;
    if (value === 'selectMember') {
      $('#memberBtnWrap').show();
      $('#excelBtnWrap').hide();
    } else if (value === 'all') {
      $('#memberBtnWrap').hide();
      $('#excelBtnWrap').hide();
      this.getMemberCount();
      $('#recipientsTargetType').val('ALL');
    } else {
      $('#memberBtnWrap').hide();
      $('#excelBtnWrap').show();
    }
  }

  private doSendImmediate() {
    if (this.isSendImmediate) {
      // $('.date-picker').prop('disabled', true);
      $('.timepicker').prop('disabled', true);
    } else {
      // $('.date-picker').prop('disabled', false);
      $('.timepicker').prop('disabled', false);
    }
  }

  private startYmd: string = addDay(new Date(), 0);
  private calendarOption = {
    fromRanges: addDay(new Date(), 0)
  };

  private selectHour: string = '00';
  private get hourList() {
    let hours = [];
    for (let i = 0; i <= 23; i++) {
      let j = '';
      if (i < 10) {
        j = '0' + i;
      } else {
        j = '' + i;
      }
      hours.push({
        value: j,
        name: j
      });
    }
    return hours;
  }

  private selectMinute: string = '00';
  private get minuteList() {
    let minute = [];
    for (let i = 0; i <= 5; i++) {
      let j = '' + i + '0';
      minute.push({
        value: j,
        name: j
      });
    }
    return minute;
  }

  private editorOnChange({html, text}: {html: string; text: string}): void {
    Object.assign(this.editorContent, {noticeContent: html, searchContent: text});
  }

  private onReset(): void {
    this.sendInformationType = '';
    this.isAd = false;
    this.changeSendInformationType();
    this.isTemplateUsed = false;
    this.recipient = 'selectMember';
    this.doRecipientRadio(this.recipient);
    this.memberCount = 0;
    this.memberNoList = [];
    this.memberList = [];
    this.isSendImmediate = true;
    this.doSendImmediate();
    this.title = '';
    this.startYmd = addDay(new Date(), 0);
    this.selectHour = '00';
    this.selectMinute = '00';
    this.contentDate = ' ';
    this.$nextTick(() => {
      this.contentDate = '';
    });

  }

  private onPreview(): void {
    if (this.isAd) {
      this.previewTitle = this.$t('MAIL_DISPATCH_TITLE_AD')
        .toString()
        .concat(this.title);
      this.previewContents = this.editorContent.noticeContent
      + '<br />' + this.$t('MAIL_DISPATCH_DESCRIPTION_6')
      + '<br />' + this.$t('MAIL_DISPATCH_DESCRIPTION_7');
    } else {
      this.previewTitle = this.title;
      this.previewContents = this.editorContent.noticeContent;
    }
    this.isPreview = true;
  }

  private async onSave() {
    await this.getAppKeyConfigured();
    if (this.isFormPassed()) {
      let request: PostMailRequest = {
        params: {
          mallNo: Number(this.mallNo)
        },
        data: {
          templateNo: this.isTemplateUsed?this.templateNo:null,
          recipientType: this.recipientType,
          messageType: this.sendInformationType === '' ? 'INFORMATION' : this.sendInformationType,
          requestDate: this.isSendImmediate?null:(this.startYmd + ' ' + this.selectHour + ':' + this.selectHour + ':00'),
          title: this.title,
          content: this.editorContent.noticeContent,
          recipients: this.memberNoList
        }
      };
      this.$api.postMail(request).then(() => {
        alert(this.$t('MAIL_DISPATCH_SUCCESS_SEND'));
        this.onReset();
      });
    }
  }

  private  isFormPassed(): boolean {
    // Email Appkey 확인
    if (!this.isAppKeyConfigured) {
      alert(this.$t('MAIL_DISPATCH_ERR_APP_KEY'));
      return false;
    }

    if (this.memberCount === 0) {
      alert(this.$t('MAIL_DISPATCH_ERR_RECIPIENT_COUNT'));
      return false;
    }

    if (!this.isSendImmediate) {
      const _MINUTE_STANDARD = 10;
      const date = this.startYmd.split('-');
      const targetDate = new Date(parseInt(date[0]), parseInt(date[1]) - 1, parseInt(date[2]), parseInt(this.selectHour), parseInt(this.selectMinute));
      const now = new Date();
      targetDate.setMinutes(targetDate.getMinutes() - _MINUTE_STANDARD);
      if (targetDate.getTime() - now.getTime() < 0) {
        alert(this.$t('MAIL_DISPATCH_ERR_TIME'));
        return false;
      }
    }
    if (!this.title) {
      alert(this.$t('MAIL_DISPATCH_ERR_TITLE'));
      return false;
    }
    if (!this.editorContent.searchContent) {
      alert(this.$t('MAIL_DISPATCH_ERR_SUMMERNOTE'));
      return false;
    }
    return true;
  }

  private async getAppKeyConfigured() {
    let request: GetMailPublicAppkeyValidationRequest = {
      params: {
        mallNo: Number(this.mallNo)
      }
    };
    await this.$api.getMailPublicAppkeyValidation(request).then(() => {
      this.isAppKeyConfigured = true;
    });
  }

  private excelDown(): void {
    let url = 'https://api-storage.cloud.toast.com/v1/AUTH_69db659103894b00aa9f8b28aa62fe8e/excel-sample/mail_recipient_template.xlsx';
    window.location.assign(url);
  }

  // private excelUpload(): void {
  //   const file = Array.from((this.$refs.addExcelFile as HTMLInputElement).files as FileList)[0];
  //   if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
  //     alert(this.$t('MAIL_DISPATCH_ERR_EXCELTYPE'));
  //     return;
  //   } else {
  //     const data = new FormData();
  //     data.append('file', file);
  //     axios({
  //       headers: {
  //         Version: process.env.VUE_APP_API_VERSION,
  //         'Content-Type': 'multipart/form-data',
  //         accessToken
  //       },
  //       data,
  //       method: 'post',
  //       url: `${process.env.VUE_APP_API_URL}/mail/recipient/excel?mallNo=${this.mallNo}`
  //     })
  //       .then((res: any) => {
  //         const memberNos = res.data;
  //         this.recipientType = 'MEMBER_NO';
  //         memberNos.forEach((member: any) => {
  //           this.memberNoList.push(Number(member.memberNo));
  //         });

  //         this.memberCount = this.memberNoList.length;
  //         this.attachedFileName = file.name;
  //       })
  //       .catch(() => {
  //         alert(this.$t('MAIL_DISPATCH_ERR_EXCEL'));
  //       });
  //   }
  // }

  private excelUpload() {
    const file = Array.from((this.$refs.addExcelFile as HTMLInputElement).files as FileList)[0];
    if (file) {
      this.uploadFile(file, (data: any) => {
          this.recipientType = 'MEMBER_NO';
          this.memberNoList = [...data.data.memberNos];
          this.memberCount = this.memberNoList.length;
          this.attachedFileName = file.name;
      });
    }
  }

  private uploadFile(file: any, callback: Function): void {
    if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
      alert(this.$t('MAIL_DISPATCH_ERR_EXCELTYPE'));
      return;
    }
    // if (file.size > 10240) {
    //   alert(this.$t('PRODUCT_STICKER_ALERT'));
    //   return;
    // }
    const data = new FormData();
    data.append('file', file);
    data.append('name', 'excelFile');
    data.append('filename', file.name);
    data.append('excelFile', file);
    this.$api.postMailRecipientExcel({data, params: {mallNo: Number(this.mallNo)}}).then((res) => {
      callback(res);
    });
    // axios({
    //   headers: {
    //     Version: '1.0',
    //     'Content-Type': 'multipart/form-data',
    //     accessToken
    //   },
    //   data,
    //   method: 'post',
    //   url: `${process.env.VUE_APP_API_URL}/images?mallNo=${this.mallNo}`
    // }).then((request: any) => {
    //   callback(request.data);
    // });
  }

  private openPop(type: string) {
    let queryString = '?mallNo=';

    switch (type) {
      case 'select':
        (window as any).membersCallback = this.callbackSelect;
        queryString += this.mallNo + '&callback=membersCallback';
        ncpPopup(`/member/popup/recipient${queryString}`, this.$t('MAIL_DISPATCH_POPUP_MEMBER_SELECT'), 635, 500);
        break;
      case 'search':
        if (!this.memberList || this.memberList.length > 0) {
          sessionStorage.setItem('checkedMembersInfo', JSON.stringify(this.memberList));
        }
        (window as any).membersCallback = this.callbackSearch;
        ncpPopup(`/member/list/popup/${this.mallNo}?callback=membersCallback`, this.$t('MAIL_DISPATCH_POPUP_MEMBER_SEARCH'), 1275, 980);
        break;
      case 'template':
        (window as any).membersCallback = this.callbackForTemplate;
        queryString += this.mallNo + '&callback=membersCallback';
        ncpPopup(`/mail/popup/template-list${queryString}`, this.$t('MAIL_DISPATCH_TEMPLATE_INUSE'), 1000, 500);
        break;
    }
  }

  private callbackSearch(selectedRows: any) {
    (window as any).membersCallback = undefined;
    sessionStorage.removeItem('checkedMembersInfo');
    this.recipientType = selectedRows.selectedType;
    this.memberList = selectedRows.selectedMembers;
    this.memberList.forEach((member: any) => {
      this.memberNoList.push(Number(member.memberNo));
    });
    this.memberCount = selectedRows.memberCount;
    // this.search(this.getMemberRequest.params.page);
  }

  private callbackSelect(data: any) {
    (window as any).membersCallback = undefined;
    this.selectedDate = JSON.stringify(data);
    this.recipientType = data.GroupOrGrade;
    if(this.recipientType === 'GRADE'){
      this.memberCount = data.gradeCount;
      this.memberList = data.GRADE;
    }else if(this.recipientType === 'GROUP'){
      this.memberCount = data.groupCount;
      this.memberList = data.GROUP;
    }
  }

  private callbackForTemplate(mailTemplatesCustom: any) {
    (window as any).membersCallback = undefined;
    this.title = mailTemplatesCustom.title;
    this.contentDate = mailTemplatesCustom.content;
    this.templateNo = mailTemplatesCustom.templateNo;
  }

  private dispatchPopupRequestData: PopupRequestData = {
    id: 'popupAdmailNotice',
    width: 850,
    maxHeight: 700,
    title: 'MAIL_DISPATCH_POPUP_TITLE',
    hasConfirmBtn: false,
    hasCloseBtn: true
  };

  private dispatchPreviewPopupRequestData: PopupRequestData = {
    id: 'previewcontent',
    width: 800,
    maxHeight: 1000,
    title: 'MAIL_DISPATCH_TITLE_PREVIEW',
    hasConfirmBtn: false,
    hasCloseBtn: true
  };

  private toFirstPage() {
    // window.location.reload();
    let url = `/mail/dispatch?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }

  private async configurations() {

    const configRequest: GetMallsDataRequest  = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
      .getNotificationsConfigurations(configRequest)
      .then(res => {
        this.emailUsed = res.data.emailUsed;
        if(res.data.outboundEmail){
          this.emailFront = res.data.outboundEmail.split('@')[0];
          this.emailEnd = res.data.outboundEmail.split('@')[1];
        }

      })
      .catch((e: any) => {
        if (e.data.code === 'MC0002') {
          this.emailUsed = false;
        }
      });
      if(!this.emailUsed){
        window.location.assign(`/mail/usage-list?mallNo=${this.mallNo}&tabNo=5`);
      }
  }

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
     await this.configurations();

  }


  private created() {
    this.dispatchPopupRequestData = i18nObjectByKey(this, this.dispatchPopupRequestData, 'title');
    this.dispatchPreviewPopupRequestData = i18nObjectByKey(this, this.dispatchPreviewPopupRequestData, 'title');
  }

  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    await this.configurations();
    this.doSendImmediate();
  }
}
